import { Box, Text, Flex } from '@chakra-ui/react';
import {useTranslation} from "react-i18next";

const RegisterSuccess = () => {
    const {t} = useTranslation("default");

    return (
        <Flex minH="100vh" align="center" justify="center" bg="#F3F3F3" px={4}>
            <Box textAlign="center" maxW="lg">
                <Text fontSize="2xl" fontWeight="bold" mb={4}>
                    {t('register.success.title')}
                </Text>
                <Text fontSize="lg">
                    {t('register.success.message')} <br />
                    {t('register.success.message2')}
                </Text>
            </Box>
        </Flex>
    );
};

export default RegisterSuccess;
